import { ComponentStepProps } from "#/ui/Modal"

import WaitingForActionModalBody from "../WaitingForActionModalBody"

import ClaimingFailedBody from "./ClaimingFailedBody"
import RewardsClaimedBody from "./RewardsClaimedBody"

type ClaimRewardsModalBodyProps = ComponentStepProps & {
  isClaiming?: boolean
  hasClaimed?: boolean
  totalMats: string
  nextStepButtonLabel?: string
}

export default function ClaimRewardsModalBody({
  isClaiming = false,
  hasClaimed = false,
  totalMats,
  onClose,
  nextStepButtonLabel,
}: ClaimRewardsModalBodyProps) {
  if (isClaiming)
    return <WaitingForActionModalBody title="Claiming reward..." />

  if (hasClaimed)
    return (
      <RewardsClaimedBody
        onClose={onClose}
        totalMats={totalMats}
        nextStepButtonLabel={nextStepButtonLabel}
      />
    )

  return <ClaimingFailedBody onClose={onClose} />
}
